import React, { useState } from 'react';
import { sendEvent } from '@alfa-bank/site-helpers-common/browser/send-event';
import cn from 'classnames';

import styles from '../../styles/styles.css';
import { useShowHook } from '../../hooks/show-hook';
import { useFeedbackLogic } from '../../hooks/form-hook';

import type { TFeedbackFormSmart } from './models';

export const FeedbackFormSmart = (props: TFeedbackFormSmart) => {
    const {
        SuccessScreen,
        FeedbackFormDumb,
        FormWrapper,
        FeedbackIcon,
        codeTeam,
        iconBias = 0,
        isMobile,
        // @ts-ignore прилетает через cloneElement от родителя, поэтому типами нормально не описывается
        isStickedByParent,
        onButtonShowAnalytics,
        onError,
        onFormShowAnalytics,
        onSend,
        onSubmitAnalytics,
        onSuccess,
        question,
        rating,
        submitEndpoint,
        timeToShow,
        className,
        topText,
        uri,
        successScreenTexts = {},
    } = props;
    const [screen, changeScreen] = useState<'start' | 'form' | 'success'>('start');
    const showIcon = useShowHook(timeToShow, () => {
        if (onButtonShowAnalytics) {
            sendEvent(onButtonShowAnalytics);
        }
    });
    const form = useFeedbackLogic({
        onSend: () => {
            changeScreen('success');
            if (onSubmitAnalytics) {
                sendEvent(onSubmitAnalytics);
            }
            if (onSend) {
                onSend();
            }
        },
        onError,
        onSuccess,
        question,
        submitEndpoint,
        codeTeam,
        uri,
    });

    return (
        <div className={cn(styles.wrapper, className)}>
            {isStickedByParent && showIcon && screen === 'start' && (
                <div
                    className={styles.showButtonWrapper}
                    onClick={() => {
                        changeScreen('form');
                        if (onFormShowAnalytics) {
                            sendEvent(onFormShowAnalytics);
                        }
                    }}
                    style={{
                        bottom: screen === 'start' ? iconBias : '-100%',
                    }}
                >
                    <FeedbackIcon />
                </div>
            )}

            {(screen === 'form' || screen === 'success') && (
                <FormWrapper onClose={/* istanbul ignore next */ () => changeScreen('start')}>
                    {screen === 'form' && (
                        <FeedbackFormDumb
                            form={form}
                            question={question}
                            rating={rating}
                            topText={topText}
                            withRatingTextHelp={isMobile}
                        />
                    )}
                    {screen === 'success' && (
                        <SuccessScreen
                            buttonText={successScreenTexts.buttonText}
                            description={successScreenTexts.description}
                            header={successScreenTexts.header}
                            onClose={/* istanbul ignore next */ () => changeScreen('start')}
                        />
                    )}
                </FormWrapper>
            )}
        </div>
    );
};
